/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {combineReducers} from 'redux';
import notificationsReducer from 'pk-react-notifications/dist/reducers';
import accountEmailChangeReducer, {AccountEmailChangeState} from './scenes/AccountEmailChange/reducers';
import resetPasswordReducer, {ResetPasswordState} from './scenes/ResetPassword/reducers';
import flexServiceWorkerRegistrationReducer, {FlexServiceWorkerRegistrationState} from './scenes/FlexServiceWorkerRegistration/reducers';
import loginReducer, {LoginState} from './scenes/Login/reducers';
import confirmEmployeeRegistrationReducer, {ConfirmEmployeeRegistrationState} from './scenes/ConfirmEmployeeRegistration/reducers';
import accountRecoveryReducer, {AccountRecoveryState} from './scenes/AccountRecovery/reducers';
import {ActionTypes, applicationStarted} from './actions';
import {getType} from 'typesafe-actions';

export interface RootState {
	application: ApplicationState;
	accountEmailChange: AccountEmailChangeState;
	accountRecovery: AccountRecoveryState;
	confirmEmployeeRegistration: ConfirmEmployeeRegistrationState;
	flexServiceWorkerRegistration: FlexServiceWorkerRegistrationState;
	login: LoginState;
	resetPassword: ResetPasswordState;
}

interface ApplicationState {
	started: boolean;
}

const applicationReducer = (state: ApplicationState = {started: false}, action: ActionTypes): ApplicationState => {
	switch (action.type) {
		case getType(applicationStarted):
			return {started: true};
		default:
			return state;
	}
};

const rootReducer = combineReducers({
	application: applicationReducer,
	accountEmailChange: accountEmailChangeReducer,
	accountRecovery: accountRecoveryReducer,
	confirmEmployeeRegistration: confirmEmployeeRegistrationReducer,
	flexServiceWorkerRegistration: flexServiceWorkerRegistrationReducer,
	login: loginReducer,
	notifications: notificationsReducer,
	resetPassword: resetPasswordReducer
});

export default rootReducer;
